import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { ClientConfigService } from '@frontend/vanilla/core';
// TODO: extract this file outside the promo-app to make it reusable
// eslint-disable-next-line @nx/enforce-module-boundaries
import { PromoClientConfiguration } from 'packages/promo/app/src/client-configs/promo-config';

@Injectable({ providedIn: 'root' })
export class PromoConfigActivateGuard implements CanActivate {
    constructor(
        private clientConfigService: ClientConfigService,
        private promoConfig: PromoClientConfiguration,
    ) {}

    async canActivate() {
        const configs = [] as any;
        if (!this.promoConfig?.isConfigReady) configs.push(PromoClientConfiguration);

        if (configs.length > 0) await this.clientConfigService.load('', configs);

        return true;
    }
}
